import { Text, Box } from '@chakra-ui/react';
import ReactDOM from 'react-dom';

interface OverlayProps {
   opacity: number;
   duration?: number;
   text: string;
}
const Overlay = ({ opacity, duration, text }: OverlayProps) =>
   ReactDOM.createPortal(
      <Box
         position="fixed"
         top="50%"
         left="50%"
         transform="translate(-50%, -50%)"
         pointerEvents="none"
         zIndex="9999"
         opacity={opacity}
         // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
         transition={`opacity ${duration / 1000}s`}
      >
         <Text
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            backgroundColor="rgba(250, 250, 250, 0.75)"
            backdropFilter="blur(5px)"
            boxShadow="2xl"
            borderRadius="md"
            color="gray.800"
            minWidth="20vw"
            minHeight="20vw"
            fontSize="5em"
         >
            {text}
         </Text>
      </Box>,
      document.body
   );

export default Overlay;
